import {loadStripe} from '@stripe/stripe-js';
import {Forms} from "./Forms/Forms";
import {Alerts} from "./Alerts";

export class Stripe {

    static init(selector) {

        $('#inputCompany').change(() => {

            if ($('[data-stripe="payment_method"]', selector).length > 0) {
                JsLoadingOverlay.show();

                axios.post('/api/company/get-stripe-key', {
                    company_id: $('#inputCompany')[0].selectize.getValue()
                }).then((response) => {

                    async function setup() {
                        return await loadStripe(atob(response.data.encoded_key));
                    }

                    setup().then(stripe => {
                        this.payment_methods(selector, stripe)
                        JsLoadingOverlay.hide();
                    })
                })
            }
        });
    }

    static payment_methods(selector, stripe) {

        let $customerSelector = $('#inputCustomer')[0].selectize;

        $(document).ready(function (){
            Stripe.getSetupIntent($('#inputCompany')[0].selectize.getValue(), $customerSelector.getValue());
        });
        $('[data-stripe="payment_method"]', selector).each((key, item) => {
            const $item = $(item),
                $form = $item.closest('form');

            const elements = stripe.elements();
            const cardElement = elements.create('card', {
                style: {
                    base: {
                        color: '#32325d',
                        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '16px',
                        '::placeholder': {
                            color: '#aab7c4'
                        }
                    },
                    invalid: {
                        color: '#fa755a',
                        iconColor: '#fa755a'
                    }
                }
            });

            cardElement.mount(item);

            // // Handle real-time validation errors from the card Element.
            cardElement.addEventListener('change', function (event) {
                let $errorContainer = $item.closest('[data-stripe-container]').find('[data-stripe-error]');

                if (event.error) {
                    $errorContainer.text(event.error.message);
                } else {
                    $errorContainer.text('');
                }
            });

            // Handle form submission.
            $form.on('submit', function (e, submit) {

                e.stopImmediatePropagation();
                e.preventDefault();


                JsLoadingOverlay.show();

                let $paymentType = $('#payment_type');

                if($('input[name="payment_method"]', $form).length > 0) {
                    Forms.submit($form);
                }

                if($paymentType.length > 0 && $paymentType[0].selectize.getValue() !== 'Stripe'){
                    Forms.submit($form);
                    JsLoadingOverlay.hide();
                    return true;
                }

                stripe.confirmCardSetup($item.attr('data-secret'), {
                    payment_method: {
                        card: cardElement
                    }
                }).then(function(result) {
                    let $errorContainer = $item.closest('[data-stripe-container]').find('[data-stripe-error]');

                    if (result.error) {
                        $errorContainer.text(result.error.message);
                        Alerts.error('Card Error: '+result.error.message)
                        JsLoadingOverlay.hide();
                    } else {
                        if (result.setupIntent.status === 'succeeded') {
                            $errorContainer.text('');
                            $form.prepend('<input type="hidden" name="payment_method" value="' + result.setupIntent.payment_method + '">');
                            Forms.submit($form, function (response){
                                if (!response.hasOwnProperty('data')){

                                    if (response.response.data.hasOwnProperty('message'))
                                        Alerts.error(response.response.data.message);
                                    if (response.response.data.hasOwnProperty('errors')) {
                                        let errorMessage = "";
                                        Object.keys(response.response.data.errors).forEach((key) => {
                                            errorMessage += key + ": " +  response.response.data.errors[key] + "\r\n";
                                        });
                                        Alerts.error(errorMessage);
                                    }

                                    //   Setup stripe intent for customer
                                    $('[name="payment_method"]').remove()
                                    Stripe.getSetupIntent($('#inputCompany')[0].selectize.getValue(),$customerSelector.getValue() ?? '')
                                }
                            });
                        } else {
                            $errorContainer.text("Something has gone wrong...");
                            JsLoadingOverlay.hide();
                        }
                    }
                }).catch(function (){
                    JsLoadingOverlay.hide();
                });

                return false;
            });
        });
    }

    static getSetupIntent(companyID, customerID)
    {
        let stripeSrc = `/api/customers/stripe-intent/${companyID}/${customerID}`;
        axios.get(stripeSrc).then(response => {
            $('[data-stripe="payment_method"]').attr('data-secret', response.data.client_secret);
            JsLoadingOverlay.hide();
        }).catch(function (e) {
            JsLoadingOverlay.hide();
        })
    }
}
